import { render } from "./screenQuote.vue?vue&type=template&id=076dfc80&scoped=true"
import script from "./screenQuote.vue?vue&type=script&lang=js"
export * from "./screenQuote.vue?vue&type=script&lang=js"

import "./screenQuote.vue?vue&type=style&index=0&id=076dfc80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-076dfc80"]])

export default __exports__